/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Report } from 'lib/models/Report';

import { loadPageData } from 'redux/actions/Request';

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

import DeleteIcon from '@material-ui/icons/DeleteOutline';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleIcon from '@material-ui/icons/AddCircle';

import SimpleTable from 'views/Components/SimpleTable';
import ActionDialog from 'views/Components/ActionDialog';
import SimpleModelForm from 'views/Components/SimpleModelForm';

const ScheduledReportsView = (props) => {

  const [savedQueries, setSavedQueries] = useState(props.savedQueries) /* eslint-disable-line */
  const [queryTypes, setQueryTypes] = useState({})
  const [state, setState] = useState({});
  const [open, setOpen] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [selectedModel, setSelectedModel] = useState(false);
  const [loading, setLoading] = useState(true); /* eslint-disable-line */

  useEffect(() => {
    setSavedQueries(props.savedQueries)
    const _queryTypes = {}
    // eslint-disable-next-line
    props.savedQueries.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())).map(savedQuery => { 
      _queryTypes[parseInt(savedQuery.params.id)] = savedQuery.params.name
    });

    setQueryTypes(props.savedQueries.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())).map(savedQuery => {
      return {value:parseInt(savedQuery.params.id), label:savedQuery.params.name}
    }));

    setState({
      columns: [
        {
          title: 'Name',
          field: 'name',
          searchable: true,
        },
        {
          title: 'Query',
          field: 'dataQueryId',
          lookup: _queryTypes,
          searchable: true,
        },
        {
          title: 'Format',
          field: 'outputType',
          lookup: { 'csv': 'CSV', 'jsonl': 'JSON' },
          searchable: true,
        },
        {
          title: 'Period',
          field: 'period',
          lookup: {
            'last-1-days': 'Prior Day',
            'last-7-days': 'Prior 7 Days',
            'last-30-days': 'Prior 30 Days',
            'previous-week': 'Previous Week',
            'previous-month': 'Previous Month',
          },
          searchable: true,
        }
      ],
      data: props.reports,
    })
  }, [props.savedQueries, props.reports])

  const handleClose = (action) => {
    selectedModel.reset()
    setOpen(false);
  };

  const handleDelete = () => {
    selectedModel.delete().then(()=>{
      props.reload(true)
      setOpenAction(false)  
    })
  }

  const onValidate = (model, fields) => {
    if(fields.period.value === 'last-7-days' || fields.period.value === 'previous-week'){
      fields.dayOfWeek.visible = true
      fields.dayOfMonth.visible = false
      selectedModel.set({ 'dayOfMonth': null })
      selectedModel.set({ 'dayOfWeek': selectedModel.dayOfWeek || fields.dayOfWeek.default })
    }else if(fields.period.value === 'last-30-days' || fields.period.value === 'previous-month'){
      fields.dayOfWeek.visible = false
      fields.dayOfMonth.visible = true
      selectedModel.set({ 'dayOfWeek': null })
      selectedModel.set({ 'dayOfMonth': selectedModel.dayOfMonth || fields.dayOfMonth.default })
    }else{
      fields.dayOfWeek.visible = false
      fields.dayOfMonth.visible = false
      selectedModel.set({ 'dayOfMonth': null })
      selectedModel.set({ 'dayOfWeek': null })
    }
    if(model.dataQueryId) {
      const dataSourceIndex = props.savedQueries.findIndex(query => query.id === model.dataQueryId)
      if (model.dataSource !== props.savedQueries[dataSourceIndex].namespace) {
        model.set({'dataSource':props.savedQueries[dataSourceIndex].namespace})
      }
    }
    return fields
  }

  const daysOfWeekName = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

  const handleEditTableRowClick = (rowDetails) => {
    //rowDetails, in this case, is really just the user info/model
    setSelectedModel(rowDetails)
    setOpen(true)
  }

  return (
      <div>
      <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth={true} maxWidth="md" >
        <DialogTitle id="simple-dialog-title">
          {selectedModel.id ? `Edit ${selectedModel.name}` : 'New Scheduled Report'}
        </DialogTitle>
        <SimpleModelForm
          spacing={1}
          model={selectedModel}
          onClose={handleClose}
          onValidate={onValidate}
          reload={() => props.reload(true)}
          actions = {[
            {
              'title': 'Cancel',
              'type': 'button',
              'action': handleClose,
            },
            {
              'title': 'Save',
              'type': 'submit',
            }
          ]}
          layout = {[
            {field: 'name', xs: 12},
            {field: 'dataQueryId', xs: 12},
            {field: 'recipients', xs: 12},
            {field: 'period', xs: 12},
            {field: 'outputType', xs: 4},
            {field: 'timeOfDay', xs: 4},
            {field: 'dayOfWeek', xs: 4},
            {field: 'dayOfMonth', xs: 4},
          ]}
          fields = {{
            'name': {
              type: 'text',
              default: '',
              label: 'Scheduled Report Name',
            },
            'dataQueryId': {
              type: 'select',
              default: queryTypes.length>0 ? queryTypes[0].value : '',
              label: 'Saved Report Name',
              lookup: queryTypes,
            },
            'recipients': {
              type: 'chip',
              default: [],
              label: 'Recipients',
            },
            'timeOfDay': {
              type: 'select',
              label: 'Time of Day (UTC)',
              default: 1,
              lookup: Array.from({length:24}, (v,k)=> {return {label:`${(k%12)||12}:00 ${k>11&&k<24?'PM':'AM'}`, value: k}})
            },
            'dayOfWeek': {
              type: 'select',
              label: 'Day of Week',
              default: 1,
              lookup: Array.from({length:7}, (v,k)=> {return {label:daysOfWeekName[k], value:(k + 6) % 7}})
            },
            'dayOfMonth': {
              type: 'select',
              label: 'Day of Month',
              default: 1,
              lookup: Array.from({length:31}, (v,k)=> {return {label:k+1, value:k+1}})
            },
            'outputType': {
              type: 'select',
              default: 'csv',
              label: 'Output Type',
              lookup: [
                {value:'csv', label:'CSV'},
                {value:'jsonl', label:'JSON'},
              ],
            },
            'period': {
              type: 'radio',
              default: 'last-1-days',
              label: 'Period',
              lookup:[
                {value:'last-1-days', label:'Prior Day'},
                {value:'last-7-days', label:'Prior 7 Days'},
                {value:'last-30-days', label:'Prior 30 Days'},
                {value:'previous-week', label:'Previous Week'},
                {value:'previous-month', label:'Previous Month'},
              ],
            },
          }}
        />
      </Dialog>
      <ActionDialog
        open={openAction}
        title={`Delete ${selectedModel.name}`}
        description='Are you sure you want to delete this report?'
        actions = {[
          {
            'title': 'Cancel',
            'action': () => setOpenAction(false)
          },
          {
            'title': 'Delete',
            'action': handleDelete
          }
        ]}
      />
      <SimpleTable
        isNorthStar
        title="Reports"
        isFetching={!props.ready}
        rowClick={handleEditTableRowClick}
        columns={state.columns}
        data={state.data}
        toolbarActions={[
          {
            icon: AddCircleIcon,
            tooltip: 'Schedule Report',
            onClick: (event, model) => {
              setSelectedModel(new Report())
              setOpen(true);
            }
          },
        ]}
        actions={[
          {
            icon: EditIcon,
            tooltip: 'Edit Report',
            onClick: (event, model) => {
              handleEditTableRowClick(model)
            }
          },
          {
            icon: DeleteIcon,
            tooltip: 'Delete Report',
            onClick: (event, model) => {
              setSelectedModel(model);
              setOpenAction(true);
            }
          }
        ]}
      />
    </div>
  )

}

const mapDispatchToProps = dispatch => {
  return {
    reload: (force) => dispatch(loadPageData(force))
  }
}

const mapStateToProps = (state, ownProps) => {
  const { query } = state

  return {
    isSaving: query.isReportsSaving,
    isDeleting: query.isDeleting,
    reportForm: query.reportForm,
    messages: query.messages,
  };
};

ScheduledReportsView.defaultProps = {
  ready: false,
  reports: [],
  savedQueries: [],
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduledReportsView);

